"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_redux_1 = require("react-redux");
var BarHor_1 = __importDefault(require("atomicComponents/atoms/Graphs/BarHor"));
var EstimateBar_1 = __importDefault(require("atomicComponents/atoms/Graphs/EstimateBar"));
var LogoAndName_1 = __importDefault(require("atomicComponents/molecules/Image/LogoAndName"));
var BarHorTitle_1 = __importDefault(require("atomicComponents/organisms/Text/BarHorTitle"));
var Money_1 = __importDefault(require("components/Money"));
var BarContainer_1 = __importDefault(require("../../Savings/styles/BarContainer"));
var selectors_1 = require("../../selectors");
var utils_1 = require("../../utils");
// I copied this over, feel free to move this around
var SavingsListRow = function (_a) {
    var item = _a.item, maxSpend = _a.maxSpend, isOpen = _a.isOpen;
    var latestAudit = (0, react_redux_1.useSelector)(selectors_1.selectLatestAudit);
    var growth = (0, utils_1.getGrowth)(latestAudit);
    var forecastSpend = (item.toolAnalysis.activeAnnualSpend || 0) * growth;
    var getPixelScale = function (amount) { return (170 * amount) / (maxSpend * growth); };
    var max = forecastSpend;
    var totalSavings = item.toolAnalysis.forecastSavings || 0;
    var min = forecastSpend - totalSavings;
    var barW = getPixelScale(forecastSpend);
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, __assign({ width: 168 }, { children: (0, jsx_runtime_1.jsx)(LogoAndName_1.default, { brand: item.service }) })), (0, jsx_runtime_1.jsxs)(BarContainer_1.default, __assign({ width: 170 }, { children: [(0, jsx_runtime_1.jsx)(BarHor_1.default, __assign({ width: barW, size: "regular", color: "pink", roundedCornerRight: true }, { children: barW > 35 && (0, jsx_runtime_1.jsx)(Money_1.default, { amount: forecastSpend, isShortened: "NEW" }) })), !isOpen && ((0, jsx_runtime_1.jsx)(BarHorTitle_1.default, { posX: getPixelScale(max), title: "Potential Savings", width: 150, value: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: totalSavings, isShortened: "NEW" }) })), (0, jsx_runtime_1.jsx)(EstimateBar_1.default, { width: getPixelScale(max - min), size: "regular", position: getPixelScale(min) })] }))] })));
};
exports.default = SavingsListRow;
